export const removePathQueryParams = (path: string) => path.split('?')[0];
